import Axios from '../axios-instance';

const purchaseOrdersAPI = {
  getPurchaseOrders: body => {
    return Axios.post(`/PurchaseOrders/Get`, body).then(({ data }) => data);
  },
  getFile: file => {
    return Axios.get(`/PurchaseOrders/GetFile/${file}`).then(({ data }) => data);
  },
  getDetail: (code, data) => {
    return Axios.post(`/PurchaseOrders/Getdetail/${code}`, data).then(({ data }) => data);
  },
};

export default purchaseOrdersAPI;
